<!-- Оздоровительно-диагностический центр / Ознакомление с Центром -->
<template>
    <div class="lang">
        <div class="info">
            <div class="full-width"><img src="/resource/img/center-bg.jpg" alt="" class="full-width--bg">
                <h3 class="title01">Wellness Center</h3>
                <h4 class="title03">
                    ХОРОШЕЕ САМОЧУВСТВИЕ — понятие, которое заключает
                    в себе как «благополучие», так и «хорошую физическую форму»,
                    и которое является основополагающим для счастливой жизни в гармонии физического,
                    психического здоровья и социальной устойчивости.
                    Оздоровительно-диагностический центр предлагает проверенные услуги по сохранению здоровья,
                    сопутствуя вам на пути к здоровой и счастливой жизни.
                </h4>
            </div>
        </div>
        <div class="info">
            <h3 class="bullet01">Индивидуальная программа</h3>
            <p class="bullet03 depth">Мы предлагаем индивидуально подобранные программы, обусловленные индивидуальными особенностями каждого клиента,</p>
            <p class="bullet03 depth">на основе личной беседы с координатором во время посещения центра или через услугу «счастливый звонок»</p>
            <p class="bullet03 depth">в Интернете, либо предварительное резервирование по телефону.</p>
        </div>
        <div class="info">
            <h3 class="bullet01">Достижение точности медицинских обследований с помощью самых современных средств медицинского назначения и квалифицированного медицинского персонала.</h3>
            <p class="bullet03 depth">Центр укомплектован опытной медицинской бригадой, обслуживающей исключительно Оздоровительно-диагностический центр, и медицинским персоналом, состоящим из готовых к сотрудничеству профессоров отделений, с
                которыми можно быстро и непосредственно связаться.</p>
            <p class="bullet03 depth">Для повышения точности результатов диагностики Центр оснащен широким спектром самого современного медицинского оборудования, в том числе КТ, МРТ, УЗИ, ПЭТ и эндоскопами.</p>
            <p class="bullet03 depth">В случае диагностирования рака или иных тяжелых заболеваний медицинский персонал и координаторы, закрепленные исключительно за Центром, будут оперативно и систематически направлять вас на амбулаторное лечение.
            </p>
        </div>
        <div class="info">
            <h3 class="bullet01">Обеспечивая первоклассное медицинское обследование</h3>
            <p class="bullet03 depth">Просторная планировка нашей клиники и комфортный зал ожидания гарантируют вам приятное медицинское обследование.</p>
            <p class="bullet03 depth">У нас предусмотрены зал ожидания и размещение VIP-персон для тех, кто желает повысить статус медицинского обследования до премиум-уровня.</p>
        </div>
    </div>
</template>
<script>

    export default {
    }

</script>